import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ReportsIndex from './ReportsIndex';
import DeadChickenReport from './DeadChickenReport';

const Reports = () => (
  <Routes>
    <Route index element={<ReportsIndex />} />
    <Route path="dead-chicken" element={<DeadChickenReport />} />
    <Route path="*" element={<Navigate to="/reports" replace />} />
  </Routes>
);

export default Reports;
